export {
  //@translate
  Investment_RiskLevel,
  Investment_IdeaType,
  //@translate
  Investment_UnitBillingPeriod,
  //@translate
  Investment_IdeaCategory,
  Investment_BuyOrderStatus,
  Investment_PositionSellStatus,
  SortDirection,
} from '../../__generated__/globalTypes';

export type Currency = 'USD' | 'RUB' | 'UTT';

export interface Money {
  value: number;
  currency: string;
}

export interface PendingDeposit {
  requestId: string;
  amount: Money;
  orderSubmitTo?: string;
}

export enum CookieKeys {
  KYCNotifyHidden = 'kycNotifyHidden',
  LoginWith2FARecomendationHiddenAt = 'LoginWith2FARecomendationHiddenAt',
}
